(function () {
  'use strict';

  var settings = window.AGILITE_GAMES_POPUP || {};
  var apiBase = String(settings.apiBase || '').replace(/\/$/, '');
  var store = String(settings.store || 'ROW-US');
  var environment = settings.environment === 'preview' ? 'preview' : 'live';
  if (!apiBase || window.__agiliteGamesPopupLoaded) return;
  window.__agiliteGamesPopupLoaded = true;

  var force = new URLSearchParams(window.location.search).get('ag_popup_force') === '1';
  var device = window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop';
  var endpoint = apiBase + '/v1/public/storefront/popup?store=' + encodeURIComponent(store)
    + '&environment=' + encodeURIComponent(environment)
    + '&path=' + encodeURIComponent(window.location.pathname)
    + '&device=' + encodeURIComponent(device);

  // --- preview diagnostics -------------------------------------------------
  // Verbose ONLY on a preview theme. `window.__isPreviewTheme` is set in
  // theme.liquid from `Shopify.theme.role` and is never true on the published
  // theme, so none of this can reach a shopper. The `[games]` prefix is not in
  // theme.liquid's PREFIX_CAT map, so it is not category-filtered -- and on live
  // console.log is left suppressed entirely, so it prints nowhere.
  // Silence it in preview with: localStorage.ag_games_quiet = '1'
  function verbose() {
    try {
      if (window.__isPreviewTheme !== true) return false;
      return window.localStorage.getItem('ag_games_quiet') !== '1';
    } catch (error) { return false; }
  }

  function say() {
    if (!verbose()) return;
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[games]');
      console.log.apply(console, args);
    } catch (error) {}
  }

  var toastHost = null;
  // Its own shadow root: the popup's styles must not leak into the page, and the
  // page's must not reach these. Built here rather than borrowing the scarcity
  // engine's toast, so this works whether or not that engine is on the page.
  function toast(text, tone) {
    if (!verbose()) return;
    // ONE STACK when there is one to join. The scarcity engine owns the page's
    // toast surface and the control panel owns its switches, so a giveaway line
    // goes there: same corner, same palette, one master switch, with a badge
    // saying which system spoke.
    //
    // The fallback below is NOT decorative. The engine ships on ROW-US only —
    // EU and IL merely stub window.SE_Engine — and a popup must be able to
    // explain itself on a storefront that has no scarcity engine at all.
    try {
      if (window.AGDebugToast && typeof window.AGDebugToast.show === 'function') {
        var kind = tone === 'skip' ? 'skip' : 'info';
        var tag = tone === 'skip' ? 'NOT OPENING' : 'GIVEAWAY';
        if (window.AGDebugToast.show({
          source: 'games', key: 'gamesPopup', kind: kind, tag: tag, text: String(text),
        })) return;
      }
    } catch (error) { /* fall through to our own */ }
    try {
      if (!toastHost) {
        toastHost = document.createElement('div');
        toastHost.id = 'agilite-games-debug';
        // A PREVIEW THEME HAS A BAR ACROSS THE BOTTOM. Anchoring to bottom:12px
        // put every line behind it — the toasts were there, and unreadable.
        // Lift above the bar when Shopify has drawn one; the same lift keeps a
        // toast clear of a sticky add-to-cart on a product page.
        try {
          var bar = document.getElementById('preview-bar-iframe')
            || document.querySelector('#preview-bar-iframe, .shopify-preview-bar');
          toastHost.style.setProperty('--ag-toast-lift', bar ? '86px' : '24px');
        } catch (error) { /* the default in the stylesheet stands */ }
        document.body.appendChild(toastHost);
        var root = toastHost.attachShadow ? toastHost.attachShadow({ mode: 'open' }) : toastHost;
        root.innerHTML = '<style>'
          + ':host{all:initial}.wrap{position:fixed;z-index:2147483100;right:24px;bottom:var(--ag-toast-lift,24px);'
          + 'display:flex;flex-direction:column-reverse;gap:12px;width:440px;max-width:calc(100vw - 48px);'
          + 'font:12px/1.45 ui-monospace,Menlo,Consolas,monospace}'
          + '.t{padding:12px 14px;border-left:3px solid #92ae74;background:#1c1c1cf2;color:#f2f2f0;'
          + 'border-radius:2px;box-shadow:0 2px 10px #0006;cursor:pointer;word-break:break-word}'
          + '.t.skip{border-left-color:#8f1814}.t.info{border-left-color:#6b7f96}'
          + '.t b{color:#92ae74;font-weight:700}</style><div class="wrap"></div>';
        toastHost.__wrap = root.querySelector('.wrap');
      }
      var el = document.createElement('div');
      el.className = 't' + (tone ? ' ' + tone : '');
      el.innerHTML = '<b>games</b> ' + String(text).replace(/[&<>]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c];
      });
      el.addEventListener('click', function () { el.remove(); });
      toastHost.__wrap.appendChild(el);
      window.setTimeout(function () { el.remove(); }, 12000);
    } catch (error) {}
  }

  function readStamp(key) {
    try { return Number(window.localStorage.getItem(key) || 0); } catch (error) { return 0; }
  }

  function writeStamp(key) {
    try { window.localStorage.setItem(key, String(Date.now())); } catch (error) {}
  }

  // The storefront's own visitor id -- the same `visitorID` that CAE, the
  // back-in-stock capture and the AGB scripts all read, so a giveaway signup
  // joins to that person's browsing rather than starting a new identity.
  // localStorage first, cookie second, matching cae-client.js.
  function visitorId() {
    try {
      var stored = window.localStorage.getItem('visitorID');
      if (stored) return String(stored);
    } catch (error) {}
    try {
      var hit = document.cookie.match(/(?:^|;\s*)visitorID=([^;]+)/);
      return hit ? decodeURIComponent(hit[1]) : '';
    } catch (error) { return ''; }
  }

  // A referral code lived only in the query string, so a click that did not
  // convert in that same visit was lost -- someone who follows a friend's link,
  // browses for two days and then signs up credited nobody. Kept here for 90
  // days instead, against the SHOP's origin, because the popup is a cross-origin
  // iframe and cannot read a cookie or storage set by the giveaway API.
  var REFERRAL_KEEP_MS = 90 * 86400000;

  function rememberReferral() {
    try {
      var code = new URLSearchParams(window.location.search).get('ref');
      if (!code) return;
      window.localStorage.setItem('ag_games_ref', JSON.stringify({
        code: String(code).slice(0, 80), at: Date.now()
      }));
      say('Referral code "' + code + '" arrived on this page and is kept for 90 days, '
          + 'so a signup days from now still credits them.');
    } catch (error) {}
  }

  function referralCode() {
    try {
      // A code on the current URL always wins: it is the link they just followed.
      var live = new URLSearchParams(window.location.search).get('ref');
      if (live) return String(live).slice(0, 80);
      var raw = window.localStorage.getItem('ag_games_ref');
      if (!raw) return '';
      var held = JSON.parse(raw);
      if (!held || !held.code) return '';
      if (Date.now() - Number(held.at || 0) > REFERRAL_KEEP_MS) {
        window.localStorage.removeItem('ag_games_ref');
        return '';
      }
      return String(held.code);
    } catch (error) { return ''; }
  }

  function readText(key) {
    try { return String(window.localStorage.getItem(key) || ''); } catch (error) { return ''; }
  }

  function writeText(key, value) {
    try { window.localStorage.setItem(key, String(value)); } catch (error) {}
  }

  // How long to wait between follow-up attempts, and how many refusals to take
  // before dropping it. Someone who has already entered has done the thing we
  // wanted; a bonus detail is not worth pestering them for.
  var FOLLOW_UP_EVERY_MS = 86400000;
  var FOLLOW_UP_MAX_SKIPS = 3;

  // The participant id this browser was given when it entered, if this popup is
  // allowed to come back for a detail the entry did not collect. Empty means the
  // ordinary rule stands: entered once, never shown again.
  function followUpTarget(candidate) {
    if (!candidate.followUp) return '';
    // Entered before follow-up existed, so no id was ever stored. Nothing to ask
    // with, and guessing is not an option.
    var participantId = readText('ag_games_pid_' + candidate.campaignKey);
    if (!participantId) return '';
    if (readStamp('ag_games_followup_done_' + candidate.campaignKey)) return '';
    if (Number(readText('ag_games_followup_skips_' + candidate.campaignKey) || 0) >= FOLLOW_UP_MAX_SKIPS) return '';
    if (Date.now() - readStamp('ag_games_followup_at_' + candidate.campaignKey) < FOLLOW_UP_EVERY_MS) return '';
    return participantId;
  }

  function isSuppressed(config) {
    if (force) return false;
    if (readStamp('ag_games_entered_' + config.campaignKey)) return true;
    // The SAME key the dismissal is written under (see writeStamp below) and
    // the same one the catalogue path reads. This one appended the revision,
    // which nothing writes, so on the fallback path the only re-show guard
    // there is could never fire and a closed popup came back on the next load.
    var dismissed = readStamp('ag_games_dismissed_' + config.surfaceKey);
    var days = Number(config.frequencyDays || 0);
    return days > 0 && dismissed > 0 && Date.now() - dismissed < days * 86400000;
  }

  // Analytics ride the existing CAE bridge (Tier A: everything in detail, no
  // backend change). If CAE is absent or blocked, the popup works unchanged.
  function emitCae(name, config, extra) {
    try {
      if (!window.CAEDev || typeof window.CAEDev.emit !== 'function') return;
      var detail = {
        surface: config.surfaceKey,
        campaign: config.campaignKey,
        revision: config.revision,
        environment: environment
      };
      for (var key in extra) detail[key] = extra[key];
      window.CAEDev.emit(name, detail);
    } catch (error) {}
  }


  // Rules this loader knows how to evaluate. A candidate that needs anything
  // else is SKIPPED, never shown: a popup displayed while quietly ignoring the
  // rule meant to hold it back is worse than no popup. New rules therefore fail
  // closed against an old loader, which is the point of `requires`.
  // `event`: the popup opens on a page signal (a DOM event on `document`)
  // instead of the timers. Listed here means this loader can listen for one;
  // a loader without it skips such a popup rather than opening it on time.
  var SUPPORTED = { path: 1, device: 1, suppress: 1, visitor: 1, referrer: 1, country: 1, event: 1 };

  // ONE TIMED CARD PER PAGE LOAD. Two candidates can now be armed at once --
  // one on a timer, one waiting for a page signal -- and `shown` lives inside
  // each arm(), so this is what stops a second TIMED card opening over the
  // first. A page signal is exempt: see show().
  var opened = false;
  // The card currently on screen, so a signal can take the screen from it.
  var openHost = null;

  function understands(candidate) {
    var needs = candidate.requires || [];
    for (var i = 0; i < needs.length; i++) if (!SUPPORTED[needs[i]]) return false;
    return true;
  }

  // Shopify Markets serves every page under locale prefixes too (/fr-fr/…,
  // /en/…) — over half of agiliteinternational.com's traffic carries one. A
  // path rule written as /products/x must cover those, so each pattern is
  // tried against the path as requested AND with one leading locale segment
  // stripped. Safe: Shopify's own first segments are never two letters.
  function stripLocale(path) {
    var stripped = String(path || '').replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/, '');
    if (stripped === path) return path;
    return stripped || '/';
  }
  
  // Shopify serves /pages/birthday and /pages/birthday/ alike, and the page
  // reports whichever spelling the link carried, so a rule written one way
  // missed arrivals the other way (2026-09-23). One trailing slash comes off
  // both sides before they meet; the root keeps its only one. The API's
  // matcher does the same.
  function unslash(path) {
    var text = String(path || '');
    return text.length > 1 && text.charAt(text.length - 1) === '/' ? text.slice(0, -1) : text;
  }

  function pathMatches(path, patterns) {
    path = unslash(path);
    var stripped = stripLocale(path);
    for (var i = 0; i < (patterns || []).length; i++) {
      var pattern = unslash(String(patterns[i] || '').trim());
      if (!pattern) continue;
      var expression = pattern.split('*').map(function (part) {
        return part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }).join('.*');
      var re = new RegExp('^' + expression + '$');
      if (re.test(path) || (stripped !== path && re.test(stripped))) return true;
    }
    return false;
  }

  function visitorIsReturning() {
    return readStamp('ag_games_first_seen') > 0;
  }

  function visitorCountry() {
    try {
      if (window.Shopify && window.Shopify.country) return String(window.Shopify.country).toUpperCase();
    } catch (error) {}
    return '';
  }

  // null = rule off, 0 = never again, N = eligible again after N days.
  function heldBy(stampKey, days) {
    if (days === null || days === undefined) return false;
    var stamp = readStamp(stampKey);
    if (!stamp) return false;
    if (Number(days) === 0) return true;
    return Date.now() - stamp < Number(days) * 86400000;
  }

  function days(n) { return n === 1 ? '1 day' : n + ' days'; }

  // Why this popup is NOT showing, in a sentence, or null when nothing holds it.
  // A reason rather than a boolean because "a rule held it" is the non-answer
  // this whole product exists not to give: the loader knows exactly which rule
  // and used to throw it away, leaving the one question worth asking -- why did
  // nothing show -- with no answer on the page where it happened.
  function holdReason(candidate) {
    if (force) return null;

    var needs = candidate.requires || [];
    for (var n = 0; n < needs.length; n++) {
      if (!SUPPORTED[needs[n]]) {
        return 'it uses a "' + needs[n] + '" rule this loader is too old to evaluate, '
          + 'so it is skipped rather than shown while ignoring the rule';
      }
    }

    var match = candidate.match || {};
    // The campaign's own sign-up form is already embedded on this page, so a
    // popup asking for the same email would be the same ask twice. Detected
    // from the embed div itself rather than an excluded path: the div is the
    // ground truth, and it keeps working when the page is renamed, moved, or
    // served under a locale prefix like /fr-fr/ or /en/ that a path rule misses.
    // Guarded: a loader that throws here shows NOTHING at all, which is a
    // worse failure than the redundancy it prevents.
    if (candidate.campaignKey && typeof document !== 'undefined' && document.querySelector) {
      var embedded = document.querySelector('[data-agilite-form]');
      if (embedded && embedded.getAttribute) {
        var embeddedKey = String(embedded.getAttribute('data-agilite-form') || '').toUpperCase();
        if (embeddedKey === String(candidate.campaignKey).toUpperCase()) {
          return 'this page already has its sign-up form embedded, so the popup would ask for the same thing twice';
        }
      }
    }
    var path = window.location.pathname;
    if (!pathMatches(path, match.includePaths || ['/*'])) {
      return 'this page (' + path + ') is not in its list of pages: '
        + (match.includePaths || ['/*']).join(', ');
    }
    if (pathMatches(path, match.excludePaths || [])) {
      return 'this page (' + path + ') is on its excluded list: ' + match.excludePaths.join(', ');
    }
    if (match.device && match.device !== 'all' && match.device !== device) {
      return 'it is set to ' + match.device + ' only, and this is ' + device;
    }

    var suppress = candidate.suppress || {};
    if (heldBy('ag_games_entered_' + candidate.campaignKey, suppress.afterEntryDays)) {
      return 'this browser entered ' + candidate.campaignKey + ', and entrants are left alone for '
        + (Number(suppress.afterEntryDays) === 0 ? 'good' : days(suppress.afterEntryDays));
    }
    if (heldBy('ag_games_dismissed_' + candidate.surfaceKey, suppress.afterDismissDays)) {
      return 'it was closed here before, and it waits '
        + (Number(suppress.afterDismissDays) === 0 ? 'for good' : days(suppress.afterDismissDays))
        + ' after being closed';
    }
    if (heldBy('ag_games_shown_' + candidate.surfaceKey, suppress.afterImpressionDays)) {
      return 'it was already shown here, and it waits '
        + (Number(suppress.afterImpressionDays) === 0 ? 'for good' : days(suppress.afterImpressionDays))
        + ' between showings';
    }
    // THE DEFAULT — entered once, never asked again — applies ONLY when no
    // "after someone enters" window was configured. The API defaults that field
    // to 0 (never), so `null` is the admin's explicit "keep showing" and a
    // number is a real window; in both cases the heldBy() check above is the
    // sole authority. This unconditional block used to override all three, so
    // "show again after 30 days" and "keep showing" both became "never again".
    // `undefined` = a config from before the field existed: the old default holds.
    if (suppress.afterEntryDays === undefined
        && readStamp('ag_games_entered_' + candidate.campaignKey) && !followUpTarget(candidate)) {
      return 'this browser already entered ' + candidate.campaignKey
        + ', and an entrant is never asked again';
    }

    var audience = candidate.audience || {};
    if (audience.visitor === 'first_visit' && visitorIsReturning()) {
      return 'it is for first-time visitors, and this browser has been here before';
    }
    if (audience.visitor === 'returning' && !visitorIsReturning()) {
      return 'it is for returning visitors, and this is a first visit';
    }
    if ((audience.countries || []).length) {
      var country = visitorCountry();
      if (!country) {
        return 'it is limited to ' + audience.countries.join(', ')
          + ', and the country of this visitor is unknown -- held rather than guessed';
      }
      if (audience.countries.indexOf(country) === -1) {
        return 'it is limited to ' + audience.countries.join(', ') + ', and this visitor is in ' + country;
      }
    }
    if ((audience.referrer || []).length) {
      var from = String(document.referrer || '');
      for (var i = 0; i < audience.referrer.length; i++) {
        if (from.indexOf(audience.referrer[i]) !== -1) return null;
      }
      return 'it is only for people arriving from ' + audience.referrer.join(', ')
        + (from ? ', and this visit came from ' + from : ', and this visit has no referrer');
    }
    return null;
  }

  function eligible(candidate) {
    return holdReason(candidate) === null;
  }


  // Cache the answer per campaign so this is one request per person, not one
  // per page view. Cleared when they enter, since that changes the answer.
  var RECOGNISE_TTL_MS = 6 * 3600000;

  function cachedRecognition(campaignKey) {
    try {
      var raw = window.localStorage.getItem('ag_games_known_' + campaignKey);
      if (!raw) return null;
      var held = JSON.parse(raw);
      if (!held || (Date.now() - Number(held.at || 0)) > RECOGNISE_TTL_MS) return null;
      return held.answer;
    } catch (error) { return null; }
  }

  function recognise(campaignKey, callback) {
    var vid = visitorId();
    if (!vid) {
      say('No visitor id on this browser, so there is nobody to recognise. Treating as new.');
      return callback(null);
    }
    var held = cachedRecognition(campaignKey);
    if (held) {
      say('recognition (cached)', held);
      return callback(held);
    }
    get(apiBase + '/v1/public/campaigns/' + encodeURIComponent(campaignKey)
        + '/visitor/' + encodeURIComponent(vid))
      .then(function (answer) {
        if (!answer) return callback(null);
        try {
          window.localStorage.setItem('ag_games_known_' + campaignKey,
            JSON.stringify({ at: Date.now(), answer: answer }));
        } catch (error) {}
        say('Recognition, from the server:', answer);
        callback(answer);
      })
      .catch(function () {
        // Unreachable: fall through to the ordinary entry form rather than
        // showing nothing. Not knowing someone is the safe default.
        say('Could not reach the recognition check, so treating this as a new visitor. '
          + 'Showing the full form is the safe answer when we do not know.');
        callback(null);
      });
  }

  function mount(config, trigger, recognition) {
    if (config.__v1 && isSuppressed(config)) return;
    var followUpId = config.followUpId || '';
    // A follow-up may turn out to have nothing to ask, in which case it is never
    // shown at all. So the impression is recorded when it actually appears, not
    // here -- otherwise a silent no-op would read as a popup the visitor saw.
    if (!followUpId) writeStamp('ag_games_shown_' + config.surfaceKey);
    // Recorded up front either way: a follow-up that fails to load must not
    // retry on every page view.
    if (followUpId) writeStamp('ag_games_followup_at_' + config.campaignKey);
    if (!readStamp('ag_games_first_seen')) writeStamp('ag_games_first_seen');
    var host = document.createElement('div');
    host.id = 'agilite-games-popup-host';
    host.setAttribute('data-surface', config.surfaceKey);
    // Whatever was up goes first -- removed, NOT dismissed: the shopper did not
    // close it, this card replaced it.
    if (openHost && openHost !== host && openHost.parentNode) {
      openHost.parentNode.removeChild(openHost);
    }
    document.body.appendChild(host);
    openHost = host;
    var root = host.attachShadow ? host.attachShadow({ mode: 'open' }) : host;
    root.innerHTML = '<style>'
      + ':host{all:initial}.scrim{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(10,10,9,.78);backdrop-filter:blur(3px);font-family:Arial,sans-serif}.shell{position:relative;flex:0 0 auto;width:min(690px,calc(100vw - 48px));transform-origin:50% 50%}iframe{display:block;width:100%;height:min(720px,calc(100vh - 48px));border:0;background:transparent;opacity:0;transition:opacity .14s ease-out}iframe.ready{opacity:1}.close{position:absolute;z-index:2;top:12px;right:12px;display:grid;width:38px;height:38px;place-items:center;border:1px solid rgba(255,255,255,.35);border-radius:0;background:#1c1c1c;color:#fff;font:20px/1 Arial,sans-serif;cursor:pointer}.close:hover,.close:focus{background:#8f1814;outline:2px solid #fff;outline-offset:2px}@media(max-width:560px){.scrim{padding:8px}.shell{width:calc(100vw - 16px)}.close{top:9px;right:9px}}@media(prefers-reduced-motion:no-preference){.scrim{animation:agFade .16s ease-out}@keyframes agFade{from{opacity:0}}}'
      + '</style><div class="scrim" role="dialog" aria-modal="true" aria-label="Agilite Games giveaway entry"><div class="shell"><button class="close" type="button" aria-label="Close giveaway">&times;</button><iframe title="Agilite Games giveaway entry" allow="clipboard-write" referrerpolicy="strict-origin-when-cross-origin"></iframe></div></div>';

    var scrim = root.querySelector('.scrim');
    var shell = root.querySelector('.shell');
    var closeButton = root.querySelector('.close');
    var frame = root.querySelector('iframe');
    var previousFocus = document.activeElement;
    var previousOverflow = document.documentElement.style.overflow;
    var naturalHeight = 0;
    // The width the popup asks its shell to be (a narrow portrait card, or the
    // wide default). 0 = never reported, so the CSS default (690px) stands.
    var desiredWidth = 0;
    var entered = false;
    var revealed = false;
    // When the panel actually became visible. The scrim goes up instantly but
    // the iframe fades in only once it is ready, so "open" and "seen" are not
    // the same moment - and a dismissal before the second one is meaningless.
    var revealedAt = 0;
    // The 1.5s net exists so a page that never reports its size still appears.
    // A follow-up gets no net: it is allowed to decide it has nothing to ask,
    // and revealing it on a timer would flash an empty box over the storefront.
    var revealTimer = followUpId ? null : window.setTimeout(reveal, 1500);
    document.documentElement.style.overflow = 'hidden';

    function reveal() {
      if (revealed) return;
      revealed = true;
      revealedAt = Date.now();
      frame.classList.add('ready');
      if (followUpId) {
        writeStamp('ag_games_shown_' + config.surfaceKey);
        emitCae('games_popup_shown', config, { trigger: 'follow_up', device: device });
      }
    }

    // Fit-to-viewport: the iframe always gets its content's full natural height
    // (so the embedded page never scrolls internally) and the shell scales down
    // as one unit when the viewport is shorter than the content. Below
    // MIN_SCALE we stop shrinking and let the frame scroll instead --
    // readability beats fit on extremely short windows.
    var MIN_SCALE = 0.55;
    function reflow() {
      if (!naturalHeight) return;
      var pad = window.matchMedia('(max-width: 560px)').matches ? 16 : 48;
      var available = Math.max(220, window.innerHeight - pad);
      var scale = Math.min(1, available / naturalHeight);
      var frameHeight = naturalHeight;
      if (scale < MIN_SCALE) {
        scale = MIN_SCALE;
        frameHeight = Math.round(available / scale);
      }
      frame.style.height = frameHeight + 'px';
      shell.style.transform = scale < 1 ? 'scale(' + Math.round(scale * 1000) / 1000 + ')' : '';
      applyWidth();
    }

    // The popup can ask for a narrower shell (a portrait card); unset keeps the
    // wide 690px default. Clamped to the viewport with the same padding reflow
    // uses, so the close button sits at the card's edge and it never spills past
    // the screen.
    function applyWidth() {
      if (!desiredWidth) return;
      var pad = window.matchMedia('(max-width: 560px)').matches ? 16 : 48;
      shell.style.width = 'min(' + desiredWidth + 'px, calc(100vw - ' + pad + 'px))';
    }

    function closePopup(recordDismissal, via) {
      if (!host.parentNode) return;
      if (recordDismissal) writeStamp('ag_games_dismissed_' + config.surfaceKey);
      // Turning down a follow-up counts. Enough refusals and it stops asking.
      if (recordDismissal && followUpId && revealed && !entered) {
        writeText(
          'ag_games_followup_skips_' + config.campaignKey,
          Number(readText('ag_games_followup_skips_' + config.campaignKey) || 0) + 1
        );
      }
      // Closing after a completed entry is not a dismissal.
      if (recordDismissal && !entered) emitCae('games_popup_dismissed', config, { via: via || 'other' });
      window.clearTimeout(revealTimer);
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('message', onMessage);
      window.removeEventListener('resize', reflow);
      document.documentElement.style.overflow = previousOverflow;
      host.parentNode.removeChild(host);
      if (openHost === host) openHost = null;
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }

    function onKeyDown(event) {
      if (event.key === 'Escape') closePopup(true, 'escape');
    }

    function onMessage(event) {
      if (event.origin !== apiBase || !event.data) return;
      // A completed popup entry can ask the parent page to navigate: the in-iframe
      // form posts {type:'agilite-games-redirect', url} to the parent after a
      // successful entry. The iframe is cross-origin and cannot move the top
      // window itself, so it hands the URL up here. Honoured only because it came
      // from apiBase (checked on the line above) and only for an https target, so
      // an http, //host, data: or javascript: URL cannot turn this into an open
      // redirect. Handled before the surfaceKey check below because this payload
      // is only {type,url} and would otherwise be dropped by that gate.
      if (event.data.type === 'agilite-games-redirect') {
        try {
          var dest = new URL(String(event.data.url || ''), window.location.href);
          if (dest.protocol === 'https:') window.top.location.href = dest.href;
        } catch (redirectError) {}
        return;
      }
      if (event.data.surfaceKey !== config.surfaceKey) return;
      if (event.data.type === 'agilite-games-popup-close') closePopup(true, 'inner');
      if (event.data.type === 'agilite-games-entry-complete') {
        entered = true;
        writeStamp('ag_games_entered_' + config.campaignKey);
        // The cached recognition answer is about a visitor who had not
        // entered yet. It lives for six hours, and nothing cleared it here,
        // so a popup re-armed inside that window could ask a fresh entrant
        // for what they had just given. The server marks that answer
        // no-store for this exact reason.
        try { window.localStorage.removeItem('ag_games_known_' + config.campaignKey); }
        catch (knownError) {}
        // Kept so a later follow-up has something to identify them with. Their
        // own id, in their own browser -- it is never sent anywhere but back to
        // the giveaway API.
        if (event.data.participantId) {
          writeText('ag_games_pid_' + config.campaignKey, event.data.participantId);
        }
      }
      // The follow-up looked and found nothing left to ask. Take the frame down
      // without ever showing it, and stop asking for good.
      if (event.data.type === 'agilite-games-popup-nothing') {
        writeStamp('ag_games_followup_done_' + config.campaignKey);
        closePopup(false, 'nothing');
        return;
      }
      if (event.data.type === 'agilite-games-followup-complete') {
        entered = true;
        emitCae('games_popup_followup_complete', config, { remaining: Number(event.data.remaining) || 0 });
        if (Number(event.data.remaining) === 0) writeStamp('ag_games_followup_done_' + config.campaignKey);
      }
      if (event.data.type === 'agilite-games-popup-resize' || event.data.type === 'agilite-games-popup-ready') {
        var reported = Math.round(Number(event.data.height) || 0);
        if (reported > 0 && reported !== naturalHeight) {
          naturalHeight = reported;
          reflow();
        }
        var reportedWidth = Math.round(Number(event.data.width) || 0);
        if (reportedWidth > 0 && reportedWidth !== desiredWidth) {
          desiredWidth = reportedWidth;
          applyWidth();
        }
        reveal();
      }
    }

    closeButton.addEventListener('click', function () { closePopup(true, 'button'); });
    // THE CLICK THAT OPENED IT MUST NOT CLOSE IT. This popup can be opened by
    // something the shopper is actively clicking - the birthday band opens it
    // on the pop that empties the sky, and the next balloon is usually already
    // being clicked. That mousedown lands on the freshly mounted scrim, which
    // dismissed a popup nobody had seen yet; worse, a scrim close is RECORDED,
    // so one stray click also suppressed the popup for frequencyDays and
    // reported a refusal (Dorian, 2026-09-16: "it dismisses the popup even
    // before the customer had a chance to see it"). The scrim now ignores
    // clicks until the panel is actually visible and has been for a moment.
    var SCRIM_GRACE_MS = 800;
    scrim.addEventListener('mousedown', function (event) {
      if (event.target !== scrim) return;
      if (!revealed || Date.now() - revealedAt < SCRIM_GRACE_MS) return;
      closePopup(true, 'scrim');
    });
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('message', onMessage);
    window.addEventListener('resize', reflow);
    // Both ids ride in the fragment, which browsers never put on the wire. The
    // render URL therefore stays identical for everyone and stays cacheable, and
    // the API never receives a visitor identifier on a cacheable request.
    //
    // The visitor id has to be handed over explicitly: the popup is a
    // cross-origin iframe, so it cannot read this page's localStorage, and
    // without it every popup signup was stored with no visitor id at all.
    var frag = [];
    var vid = visitorId();
    if (vid) frag.push('v=' + encodeURIComponent(vid));
    if (followUpId) frag.push('followup=' + encodeURIComponent(followUpId));
    // What the server said is still missing. The render page asks for exactly
    // this and nothing else, so a recognised visitor never sees an email field
    // they already filled in somewhere else.
    if (recognition && recognition.known && (recognition.ask || []).length) {
      frag.push('ask=' + encodeURIComponent(recognition.ask.join(',')));
    }
    // WHAT WE HOLD, which is what the page's asking rules actually run on. `ask`
    // above is the older wire: a finished list of fields to show, which can only
    // express "ask these". A field can now wait on a detail we hold rather than
    // one we are asking for, so the page needs the FACTS, not a verdict — and it
    // re-derives the same answer the server pre-rendered from them.
    //
    // Same channel and same reasoning as the visitor id: the fragment is never
    // sent on the wire, so the render URL stays identical for everyone and stays
    // cacheable. `v=` is pushed above, and the page only trusts a `known=` that
    // arrives alongside it — a hand-typed one claims knowledge nobody has.
    if (recognition && recognition.known && (recognition.onFile || []).length) {
      frag.push('known=' + encodeURIComponent(recognition.onFile.join(',')));
    }
    var ref = referralCode();
    if (ref) {
      frag.push('ref=' + encodeURIComponent(ref));
      say('Crediting referral code "' + ref + '" on this entry.');
    }
    // Campaign attribution rides the fragment too. The popup is a cross-origin
    // iframe and its render URL is server-authored with no ?utm_*, so the SHOP
    // page's query string is the only place these live. The render-page form now
    // reads matching hidden fields off the fragment, so an entry from a utm-tagged
    // landing page is credited to that source/medium/campaign. Only the fragment
    // grows -- renderUrl stays identical and cacheable, and these never touch the
    // wire, matching how the visitor id is handled above.
    var shopQuery = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (utmKey) {
      var utmVal = shopQuery.get(utmKey);
      if (utmVal) frag.push(utmKey + '=' + encodeURIComponent(String(utmVal).slice(0, 200)));
    });
    // The storefront's ACTIVE LANGUAGE, so the popup renders the form's
    // translation for the page the shopper is actually on. IL serves Hebrew at
    // "/" and English at "/en", and `Shopify.routes` does not exist on these
    // stores, so the <html lang> the theme already emits is the truthful signal.
    // Only the primary subtag is sent ("he", not "he-IL"). This DOES vary the
    // render URL -- one cache entry per language instead of one overall, which is
    // the point: the same URL cannot serve two languages.
    var pageLang = String(document.documentElement.getAttribute('lang') || '')
      .trim().toLowerCase().split('-')[0];
    var renderUrl = config.renderUrl;
    if (pageLang) {
      renderUrl += (renderUrl.indexOf('?') === -1 ? '?' : '&') + 'lang=' + encodeURIComponent(pageLang);
    }
    frame.src = renderUrl + (frag.length ? '#' + frag.join('&') : '');
    closeButton.focus();
    if (!followUpId) emitCae('games_popup_shown', config, { trigger: trigger || 'delay', device: device });
  }

  function arm(config) {
    var shown = false;
    var timer = null;
    function show(trigger) {
      // ONE CARD PER PAGE LOAD - UNLESS THE SHOPPER ASKS AGAIN. A timed popup
      // opens once and then leaves the page alone. A page signal is a gesture:
      // emptying the balloon sky a second time earns the reward a second time,
      // and the rules on the popup govern page load to page load, not this. So
      // an event popup is released as soon as the previous card has left the
      // screen (Dorian, 2026-09-16: "doing the ballon things again it doesnt
      // respawn the popup").
      var onScreen = !!(openHost && openHost.parentNode);
      if (shown && !(config.showOnEvent && !onScreen)) return;
      // A GESTURE IS NOT AN INTERRUPTION. A timed popup must not open over a
      // card that is already up; a page signal may, because the shopper caused
      // it -- they popped every balloon -- and refusing them the thing they just
      // asked for is the opposite of restraint.
      if (opened && !config.showOnEvent) {
        say('Not opening ' + config.campaignKey + ': another popup already opened on this page.');
        return;
      }
      shown = true;
      opened = true;
      if (timer) window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExit);
      say('Trigger "' + trigger + '" fired for ' + config.campaignKey + '. Asking who this is.');

      // THE LAST GATE, moved in front of everything that speaks. It used to sit
      // inside mount(), which runs AFTER the recognition toast has announced
      // which fields are coming -- so the storefront said "showing phone only"
      // and then nothing appeared, with no reason given anywhere. Nothing may be
      // announced before the decision that can stop it.
      if (config.__v1 && isSuppressed(config)) {
        var why = readStamp('ag_games_entered_' + config.campaignKey)
          ? 'this browser is stamped as having entered ' + config.campaignKey
          : 'this popup was dismissed less than ' + Number(config.frequencyDays || 0) + ' days ago';
        var held = 'Not opening: ' + why + '. Add ?ag_popup_force=1 to the address to see it anyway.';
        say(held);
        toast(held, 'skip');
        return;
      }

      // Asked only now, not on page load: a visitor who never triggers a popup
      // costs no request at all.
      recognise(config.campaignKey, function (answer) {
        var fields = (answer && answer.ask) || [];
        var listed = fields.join(' and ');

        if (answer && answer.alreadyEntered) {
          // THE AFTER-ENTRY WINDOW IS THE AUTHORITY HERE TOO. This branch used
          // to stop every entrant outright, in the last moment before mounting,
          // after holdReason had already read the popup's rule and let it
          // through -- so a popup set to "open on every occasion" opened once
          // per browser and never again. Read BEFORE the stamp below, or
          // writing it would itself be what holds them back on a window rule.
          var entryDays = (config.suppress || {}).afterEntryDays;
          var neverAgain;
          if (entryDays === undefined) neverAgain = true;                 // a config from before the field existed
          else if (entryDays === null) neverAgain = false;                // "open on every occasion"
          else if (Number(entryDays) === 0) neverAgain = true;            // "never again on that browser"
          else neverAgain = heldBy('ag_games_entered_' + config.campaignKey, entryDays);
          // Recorded locally too, so the next page load answers without asking
          // the server -- and so this holds even if the browser data that would
          // have stamped it was cleared.
          writeStamp('ag_games_entered_' + config.campaignKey);
          // A FOLLOW-UP IS FOR ENTRANTS. Returning here meant the one popup
          // written to come back for a missing detail could never open for the
          // only people it exists for.
          if (neverAgain && !config.followUpId) {
            var entered = 'Not opening: this browser has already entered '
              + config.campaignKey + ', and this popup leaves entrants alone';
            entered += Number(entryDays) === 0 || entryDays === undefined ? ' for good.' : ' for now.';
            say(entered);
            toast(entered, 'skip');
            return;
          }
          if (!neverAgain) {
            say('Already an entrant of ' + config.campaignKey
                + ', and this popup is set to open for them again. A campaign that hands out a code '
                + 'shows the SAME one rather than minting a second.');
          }
        }

        // WHETHER THERE IS ANYTHING LEFT TO COLLECT, which is the server's
        // answer now, not a guess from the shape of a list. An empty `ask` only
        // means no CANDIDATE is left; a form whose name and email are shown to
        // everyone still has a form to fill in, and closing the popup on those
        // shoppers lost entries. Older cached answers carry no `nothingToAsk`,
        // so they keep today's test.
        var holdsEverything = answer && (answer.nothingToAsk === true
          || (answer.nothingToAsk === undefined && !fields.length));
        if (answer && answer.known && holdsEverything) {
          var complete = 'Not opening: this browser is linked to an email address, and we already '
            + 'hold everything ' + config.campaignKey + ' asks for. Nothing to collect, so nothing '
            + 'to interrupt them for. They can still enter from an email or a shared link.';
          say(complete);
          toast(complete, 'skip');
          return;
        }

        if (answer && answer.known) {
          // Says what we HOLD, not which boxes will be on the card: the page
          // works that out from its own rules, and a toast that names fields
          // asserts a layout it did not compute.
          var held = (answer.onFile || []).join(' and ') || 'nothing yet';
          var asking = 'Recognised: we already hold ' + held + '. The form skips what is '
            + 'on record and applies its asking rules.';
          say(asking);
          toast(asking, 'info');
        } else {
          var fresh = 'Showing the full entry form: nothing links this browser to an email address, '
            + 'so everything is still to collect.';
          say(fresh);
          toast(fresh, 'info');
        }
        mount(config, trigger, answer);
      });
    }
    function onScroll() {
      var scrollable = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      if ((window.scrollY / scrollable) * 100 >= Number(config.scrollPercent || 0)) show('scroll');
    }
    function onExit(event) {
      if (config.exitIntent && device === 'desktop' && event.clientY <= 0 && !event.relatedTarget) show('exit');
    }
    // OPENS ON A PAGE SIGNAL. When the candidate names a DOM event, the three
    // timers are not started at all -- the page decides when, not the clock.
    // First use: the birthday band fires `agb:bday-all-popped` every time the
    // sky is emptied. NOT `once`: the balloons come back, so the shopper can
    // clear the band again, and show() lets an event popup through whenever the
    // previous card has gone. Listening starts here, at arming, which is well
    // before any human can pop a sky full of balloons.
    if (config.showOnEvent) {
      say('Waiting for the page signal "' + config.showOnEvent + '" before opening ' + config.campaignKey + '.');
      document.addEventListener(config.showOnEvent, function () { show('event'); });
      if (force) show('force');
      return;
    }
    timer = window.setTimeout(function () { show('delay'); }, Math.max(0, Number(config.delaySeconds || 0)) * 1000);
    if (Number(config.scrollPercent || 0) > 0) window.addEventListener('scroll', onScroll, { passive: true });
    if (config.exitIntent) document.addEventListener('mouseout', onExit);
    if (force) show('force');
  }

  rememberReferral();

  var catalogue = apiBase + '/v1/public/storefront/popups?store=' + encodeURIComponent(store)
    + '&environment=' + encodeURIComponent(environment)
    // The preview token unlocks the FULL candidate list so a suppressed popup
    // falls through to the next one. Without it the API truncates to the top
    // candidate (and says so with previewLimited) rather than refusing.
    + (environment === 'preview' && settings.previewToken ? '&t=' + encodeURIComponent(settings.previewToken) : '');

  function get(url) {
    return window.fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit', headers: { Accept: 'application/json' } })
      // A 204 is an ANSWER -- the server has nothing eligible here. Anything
      // else that is not ok is a FAILURE, and the two used to arrive as the
      // same null. Rejecting lets the .catch below fall back on a failure
      // without falling back on an answer.
      .then(function (response) {
        if (response.status === 204) return null;
        if (!response.ok) throw new Error('catalogue ' + response.status);
        return response.json();
      });
  }

  // The catalogue is the ordered list of everything eligible on the server's
  // side. Walking it here is what lets a suppressed popup fall through to the
  // next one instead of leaving the visitor with nothing.
  get(catalogue)
    .then(function (body) {
      if (!body || !body.candidates || !body.candidates.length) {
        // Nothing eligible, which the catalogue already decided. Asking the
        // older single-popup endpoint cannot change that answer, and that
        // request carries the shopper's full pathname -- the per-visitor
        // logging the catalogue was built to remove. A FAILED request is a
        // different thing and still falls back, in the .catch below.
        say('No popup is eligible on this page.');
        return;
      }
      say('Catalogue returned ' + body.candidates.length + ' popup(s) for this page, in priority order.');
      // A TIMER CANDIDATE AND A SIGNAL CANDIDATE ARE NOT RIVALS. The first wants
      // a moment on this page; the second waits for something the page may never
      // do -- the birthday band finishing its balloons -- and costs nothing until
      // it happens. Arming only the top candidate meant one five-second timer
      // popup starved every signal popup beneath it, for ever.
      var armedTimer = false;
      var armedSignal = false;
      for (var i = 0; i < body.candidates.length; i++) {
        var held = holdReason(body.candidates[i]);
        if (held) {
          say('Not "' + body.candidates[i].surfaceKey + '": ' + held + '.');
          toast('Not showing "' + body.candidates[i].surfaceKey + '" - ' + held + '.', 'skip');
          continue;
        }
        var waitsForSignal = !!((body.candidates[i].trigger || {}).event);
        if (waitsForSignal ? armedSignal : armedTimer) {
          say('Already have a ' + (waitsForSignal ? 'page-signal' : 'timed')
              + ' popup armed, so "' + body.candidates[i].surfaceKey + '" stays back.');
          continue;
        }
        if (true) {
          var chosen = body.candidates[i];
          var trigger = chosen.trigger || {};
          arm({
            surfaceKey: chosen.surfaceKey,
            campaignKey: chosen.campaignKey,
            revision: chosen.revision,
            renderUrl: chosen.renderUrl,
            delaySeconds: trigger.delaySeconds,
            scrollPercent: trigger.scrollPercent,
            exitIntent: trigger.exitIntent,
            // A page signal to wait for instead of the timers. Only ever set on
            // a candidate that also requires `event`, so it never reaches a
            // loader that would ignore it.
            showOnEvent: String(trigger.event || ''),
            // The re-show rules travel WITH the card: the last gate before
            // mounting has to consult the same window holdReason did.
            suppress: chosen.suppress,
            // Non-empty only when this visitor has already entered and the popup
            // is allowed to come back for a detail the entry did not collect.
            followUpId: followUpTarget(chosen)
          });
          if (waitsForSignal) armedSignal = true; else armedTimer = true;
          // Nothing left to look for once both kinds are armed.
          if (armedTimer && armedSignal) return;
          continue;
        }
      }
    })
    .catch(function () {
      // Anything unexpected falls back to the behaviour that was already live.
      get(endpoint).then(function (config) { if (config) { config.__v1 = true; arm(config); } }).catch(function () {});
    });
})();
